import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { firstValueFrom } from 'rxjs';
import { API_ROUTES } from '../_constants/api-route.constant';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private http: MainService
  ) { }


  async uploadFile(fileOrFiles: File | File[]): Promise<string | string[] | undefined> {
    try {
      // If it's a single file, upload it directly
      if (fileOrFiles instanceof File) {
        const response = await firstValueFrom(
          this.http.postFile(`${API_ROUTES.ACCOUNT.uploadImage}`, fileOrFiles)
        );
        return response?.data?.url;
      }

      // If it's an array, upload all files in parallel
      const uploadPromises = fileOrFiles.map(file =>
        firstValueFrom(
          this.http.postFile(`${API_ROUTES.ACCOUNT.uploadImage}`, file)
        ).then(response => response?.data?.url)
          .catch(() => undefined)
      );

      const results = await Promise.all(uploadPromises);
      return results.filter((url): url is string => !!url);
    } catch (err) {
      console.error('Upload failed:', err);
      return undefined;
    }
  }

}
